<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="line"></div>
        <div class="main__con__ttl">
          <div class="box__con__route_name type_02"> <!--세로정렬-->
            <span class="academy" style="text-align: center;">{{ subject }}</span>
          </div>
        </div>
        <div class="sign__page">
          <div class="form">
            <ul class="form__ul">
              <li class="form__li">
                <div class="checkbox_line">
                  <label class="checkbox">
                    <input type="checkbox" v-model="params.isAll" @change="changeIsAllHandler">
                    <span class="label"><span>전체 선택</span></span>
                  </label>
                </div>
              </li>
              <li class="form__li" v-for="(item, index) in [1,2,3,4,5,6,7,8,9,10,11,12]" :key="index">
                <div class="checkbox_line">
                  <label class="checkbox">
                    <input type="checkbox" v-model="params.month" :value="`${item}월`" @change="changeMonthHandler">
                    <span class="label"><span>{{ item }}월</span></span>
                  </label>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">받을 E-Mail</div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="email" placeholder="E-Mail을 입력해주세요." v-model="params.researchEmail">
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm on" @click="requestResearch()">연구일지 신청</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      subject: this.$route.query.subject,
      params: {
        researchNo: this.$route.query.researchNo,
        researchEmail: '',
        isAll: false,
        month: []
      }
    };
  },
  created: function () {

  },
  methods: {
    changeIsAllHandler: function ($event) {
      if ($event.target.checked === true) {
        this.params.month = []
      }
    },
    changeMonthHandler: function ($event) {
      if ($event.target.checked === true) {
        this.params.isAll = false
      }
    },
    requestResearch: async function () {
      if (this.params.isAll === false && this.params.month.length <= 0) {
        this.$Util.modalAlert({message: '월을 선택해 주세요.'})
        return false
      }

      if (this.params.researchEmail === '') {
        this.$Util.modalAlert({message: '받을 E-Mail을 입력해 주세요.'})
        return false
      }

      this.params.isAll = this.params.isAll ? 1 : -1
      this.params.month = this.params.month.join(', ')
      const res = await this.$LabSvc.requestResearch(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.$Util.modalAlert({message: '신청 되었습니다.'}, function () {
          this.$router.go(-1)
        })
      }
    }
  }
};
</script>
